__turbopack_context__.v({
  "added": "buy-the-look-module-scss-module__l0Ju6G__added",
  "box": "buy-the-look-module-scss-module__l0Ju6G__box",
  "caption": "buy-the-look-module-scss-module__l0Ju6G__caption",
  "check": "buy-the-look-module-scss-module__l0Ju6G__check",
  "choose": "buy-the-look-module-scss-module__l0Ju6G__choose",
  "close": "buy-the-look-module-scss-module__l0Ju6G__close",
  "cover": "buy-the-look-module-scss-module__l0Ju6G__cover",
  "cta": "buy-the-look-module-scss-module__l0Ju6G__cta",
  "head": "buy-the-look-module-scss-module__l0Ju6G__head",
  "need": "buy-the-look-module-scss-module__l0Ju6G__need",
  "panel": "buy-the-look-module-scss-module__l0Ju6G__panel",
  "panel-body": "buy-the-look-module-scss-module__l0Ju6G__panel-body",
  "panel-head": "buy-the-look-module-scss-module__l0Ju6G__panel-head",
  "panel-sum": "buy-the-look-module-scss-module__l0Ju6G__panel-sum",
  "panel-title": "buy-the-look-module-scss-module__l0Ju6G__panel-title",
  "panel-total": "buy-the-look-module-scss-module__l0Ju6G__panel-total",
  "remove": "buy-the-look-module-scss-module__l0Ju6G__remove",
  "row": "buy-the-look-module-scss-module__l0Ju6G__row",
  "row-body": "buy-the-look-module-scss-module__l0Ju6G__row-body",
  "row-head": "buy-the-look-module-scss-module__l0Ju6G__row-head",
  "row-name": "buy-the-look-module-scss-module__l0Ju6G__row-name",
  "row-price": "buy-the-look-module-scss-module__l0Ju6G__row-price",
  "row-thumb": "buy-the-look-module-scss-module__l0Ju6G__row-thumb",
  "sum": "buy-the-look-module-scss-module__l0Ju6G__sum",
  "thumb": "buy-the-look-module-scss-module__l0Ju6G__thumb",
  "tile": "buy-the-look-module-scss-module__l0Ju6G__tile",
  "tile-name": "buy-the-look-module-scss-module__l0Ju6G__tile-name",
  "tile-price": "buy-the-look-module-scss-module__l0Ju6G__tile-price",
  "tiles": "buy-the-look-module-scss-module__l0Ju6G__tiles",
  "title": "buy-the-look-module-scss-module__l0Ju6G__title",
  "total": "buy-the-look-module-scss-module__l0Ju6G__total",
});
